module.exports = __webpack_public_path__ + "870d82660f85d4369128fb478aa860c5.pdf";